import React from "react";

import { ProfileLink } from "app/links";
import { Trans } from "app/utils";

import FeedItemTitle from "./FeedItemTitle";

const OrganizationValueCreated = ({ item }) => {
  const user = item.users[0];

  return (
    <div className="FeedItem__preview__organization_values_created">
      <FeedItemTitle item={item} date={item.bumpedAt}>
        {user && <ProfileLink user={user} />}{" "}
        <Trans>A new organization value was added: </Trans>
        <strong>{item.entity.name}</strong>
      </FeedItemTitle>
    </div>
  );
};

export default OrganizationValueCreated;
